<div class="main-db gap-top">
  <div class="container-fluid mt-2">

    <div class="row">      
      <div class="col-12 col-sm-6">
        <h1>{{title}}</h1>
      </div>
    </div>

    <div class="form-group p-1 pl-2 col-sm-3 col-4 float-left">
      <!-- <label>Select Date Range</label> -->
      <input readonly type="text" matInput placeholder="Select Date Range"
        class="form-control form-control-sm  input-custom pl-2 mt-0"
        ngxDaterangepickerMd
        [locale]="{format: 'YYYY-MM-DD'}"
        [(ngModel)]="selected"
        startKey="start"
        endKey="end"
        [showCustomRangeLabel]="true"
        [alwaysShowCalendars]="true"
        [linkedCalendars]="true"
        name="daterange"/>
    </div>
  
    <div class="col-sm-4 col-8 float-left form-group p-1">
      <select class="form-control form-control-sm input-custom" (change)="selectOrg($event.target.value)">
        <option value="" >Select Organization</option>
        <option *ngFor="let orgObject of orgData" [value]="orgObject.id">{{orgObject.name}}</option>
      </select>
    </div>
  
    <div class="form-group p-1 col-sm-1 col-6 float-left">
      <input class="btn btn-sm btn-success w-100" type="button" (click)="searchOrgData()" value="Search"/>
    </div>
  
    <div class="form-group p-1 col-sm-3 col-3 float-right">
      <a type="button" class="mr-3 mt-2 float-right" (click)="excelSheetDownload()">
        <i class="fa fa-download mr-1" aria-hidden="true"></i> Export Shift Report
      </a>
      <a type="button" class="mr-3 mt-2 float-right" (click)="downloadChartImage($event)">
        <i class="fas fa-image mr-1" aria-hidden="true"></i> Export Chart PNG
      </a>
    </div>
  
  
    <div class="container-fluid">
      <div>
        <div style="display: block">
          <canvas baseChart id="monthlyChart"
                  [datasets]="barChartData"
                  [labels]="barChartLabels"
                  [options]="myoption"
                  [legend]="barChartLegend"
                  [chartType]="barChartType">
          </canvas>
        </div>
      </div>
    </div>

  </div>
</div>